(function () {
  // Fallback only: 'cart-drawer' renders the section with schema DEFAULTS,
  // not the configured instance inside the overlay group, which computes
  // eligibility against the wrong campaign. Always prefer the real
  // instance ID resolved from the DOM (shopify-section-sections--...).
  const SECTION_ID_FALLBACK = 'cart-drawer';
  const SLOT_SELECTOR = '#ks-free-shipping-progress-slot';
  const RATE_LIMIT_BACKOFF_MS = 10000;

  let refreshTimer = null;
  let observer = null;
  let isApplyingUpdate = false;
  let rateLimitedUntil = 0;

  function getRootUrl() {
    return window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
  }

  function getSectionId() {
    const slot = document.querySelector(SLOT_SELECTOR);
    const section = slot ? slot.closest('[id^="shopify-section-"]') : null;

    if (section) {
      return section.id.replace('shopify-section-', '');
    }

    return SECTION_ID_FALLBACK;
  }

  function getDrawerRoot() {
    return (
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('[data-cart-drawer-inner]') ||
      document.querySelector('.drawer__body')
    );
  }

  // Whole dollars, rounded up so "add $X more" is never short.
  function formatMoney(cents) {
    return '$' + Math.ceil(Number(cents || 0) / 100).toLocaleString();
  }

  function scheduleRefresh(delay = 700) {
    if (Date.now() < rateLimitedUntil) return;

    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(function () {
      refreshProgressValues();
    }, delay);
  }

  async function refreshProgressValues() {
    const liveSlot = document.querySelector(SLOT_SELECTOR);
    if (!liveSlot) return;
    if (Date.now() < rateLimitedUntil) return;

    const sectionId = getSectionId();

    try {
      const requestUrl =
        `${getRootUrl()}?sections=${sectionId}&sections_url=${window.location.pathname}`;

      const response = await fetch(requestUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        cache: 'no-store'
      });

      if (response.status === 429) {
        rateLimitedUntil = Date.now() + RATE_LIMIT_BACKOFF_MS;
        console.warn('[KS Cart Progress] Rate limited (429), backing off 10s');
        return;
      }

      if (!response.ok) return;

      const sections = await response.json();
      const updatedHtml = sections[sectionId];

      if (!updatedHtml) return;

      const parsedHtml = new DOMParser().parseFromString(updatedHtml, 'text/html');
      const updatedSlot = parsedHtml.querySelector(SLOT_SELECTOR);

      if (!updatedSlot) return;

      applyProgressState(liveSlot, updatedSlot);
    } catch (error) {
      console.warn('[KS Cart Progress] Refresh failed:', error);
    }
  }

  function applyProgressState(liveSlot, updatedSlot) {
    const eligibleTotal = Number(updatedSlot.dataset.ksEligibleTotal || 0);

    const threshold = Number(
      liveSlot.dataset.ksThreshold ||
      updatedSlot.dataset.ksThreshold ||
      0
    );

    const minimumThreshold = Number(
      liveSlot.dataset.ksMinimumThreshold ||
      updatedSlot.dataset.ksMinimumThreshold ||
      0
    );

    const enableOfferProgress =
      liveSlot.dataset.ksEnableOfferProgress === 'true' ||
      updatedSlot.dataset.ksEnableOfferProgress === 'true' ||
      liveSlot.dataset.ksEnableMaxStatus === 'true' ||
      updatedSlot.dataset.ksEnableMaxStatus === 'true';

    let nextState = 'empty';

    if (
      minimumThreshold > 0 &&
      eligibleTotal > 0 &&
      eligibleTotal < minimumThreshold
    ) {
      nextState = 'minimum';
    } else if (
      enableOfferProgress &&
      threshold > 0 &&
      eligibleTotal >= threshold
    ) {
      nextState = 'max';
    } else if (eligibleTotal > 0) {
      nextState = 'offer';
    }

    let progressBase = threshold;

    if (nextState === 'minimum') {
      progressBase = minimumThreshold;
    } else if (!enableOfferProgress) {
      progressBase = minimumThreshold;
    }

    let progressPercent = 0;

    if (progressBase > 0) {
      progressPercent = Math.min(
        100,
        Math.round((eligibleTotal * 100) / progressBase)
      );
    }

    const minimumRemaining = Math.max(0, minimumThreshold - eligibleTotal);

    const offerRemaining = enableOfferProgress
      ? Math.max(0, threshold - eligibleTotal)
      : 0;

    isApplyingUpdate = true;

    liveSlot.dataset.ksState = nextState;
    liveSlot.dataset.ksEligibleTotal = String(eligibleTotal);
    liveSlot.dataset.ksEligibleCount = updatedSlot.dataset.ksEligibleCount || liveSlot.dataset.ksEligibleCount || '0';
    liveSlot.dataset.ksEligibleCollections =
      updatedSlot.dataset.ksEligibleCollections || liveSlot.dataset.ksEligibleCollections || '';
    liveSlot.dataset.ksEnableOfferProgress = String(enableOfferProgress);
    liveSlot.dataset.ksEnableMaxStatus = String(enableOfferProgress);

    const minimumRemainingEl = liveSlot.querySelector(
      '.ks-cart-campaign__remaining--minimum'
    );

    const offerRemainingEl = liveSlot.querySelector(
      '.ks-cart-campaign__remaining--offer'
    );

    const minimumBarFillEl = liveSlot.querySelector(
      '.ks-cart-campaign__bar-fill--minimum'
    );

    const offerBarFillEl = liveSlot.querySelector(
      '.ks-cart-campaign__bar-fill--offer'
    );

    const maxBarFillEl = liveSlot.querySelector(
      '.ks-cart-campaign__bar-fill--max'
    );

    if (minimumRemainingEl) {
      minimumRemainingEl.textContent = formatMoney(minimumRemaining);
    }

    if (offerRemainingEl) {
      offerRemainingEl.textContent = enableOfferProgress
        ? formatMoney(offerRemaining)
        : '';
    }

    if (minimumBarFillEl) {
      minimumBarFillEl.style.width =
        nextState === 'minimum' ? progressPercent + '%' : '0%';
    }

    if (offerBarFillEl) {
      if (enableOfferProgress) {
        offerBarFillEl.style.width =
          nextState === 'offer' ? progressPercent + '%' : '0%';
      } else {
        offerBarFillEl.style.width =
          nextState === 'offer' ? '100%' : '0%';
      }
    }

    if (maxBarFillEl) {
      maxBarFillEl.style.width = '100%';
    }

    syncNewCustomerBlock(liveSlot, updatedSlot);

    syncGiftBlock(liveSlot, updatedSlot);

    syncCheckoutCtaState(nextState);

    document.dispatchEvent(
      new CustomEvent('ks:cart-state:updated', {
        detail: {
          state: nextState,
          eligibleTotal: eligibleTotal,
          threshold: threshold,
          minimumThreshold: minimumThreshold
        }
      })
    );

    window.setTimeout(function () {
      isApplyingUpdate = false;
    }, 0);
  }

  // The new-customer code block lives INSIDE the slot and is re-rendered by
  // the server on every refresh, so we swap the whole node rather than patching
  // numbers here. Its "訂單再加 $X" is computed from cart.total_price, which is a
  // different base than the campaign progress bar above it — duplicating that
  // arithmetic in JS is how the two $99s drift apart.
  function syncNewCustomerBlock(liveSlot, updatedSlot) {
    const SEL = '[data-ks-new-customer-code]';
    const live = liveSlot.querySelector(SEL);
    const next = updatedSlot.querySelector(SEL);

    // The sticky cart bar renders off these, so they have to travel with the
    // block. They are order-total based — NOT the same base as ksEligibleTotal.
    const NC_DATA = ['ksNcMin', 'ksNcGap', 'ksNcOrderTotal', 'ksNcItemCount'];

    if (next) {
      const fresh = document.importNode(next, true);

      if (live) {
        live.replaceWith(fresh);
      } else {
        liveSlot.appendChild(fresh);
      }

      liveSlot.dataset.ksNc = '1';
      NC_DATA.forEach(function (key) {
        if (updatedSlot.dataset[key] !== undefined) {
          liveSlot.dataset[key] = updatedSlot.dataset[key];
        }
      });
      return;
    }

    // No block in the fresh render (signed out, or the customer just placed
    // an order in another tab) — drop it rather than leaving a stale code up.
    if (live) {
      live.remove();
    }

    liveSlot.dataset.ksNc = '0';
    NC_DATA.forEach(function (key) { delete liveSlot.dataset[key]; });
  }

  // Gift engine (ks-gift-block.liquid) renders its state JSON + cards inside the
  // slot too. Swap the whole block so Liquid stays the single source of truth,
  // then tell ks-gift-engine.js a fresh server state is available.
  function syncGiftBlock(liveSlot, updatedSlot) {
    const SEL = '[data-ks-gift-block]';
    const live = liveSlot.querySelector(SEL);
    const next = updatedSlot.querySelector(SEL);

    if (next) {
      const fresh = document.importNode(next, true);
      if (live) live.replaceWith(fresh); else liveSlot.appendChild(fresh);
    } else if (live) {
      live.remove();
    }

    document.dispatchEvent(new CustomEvent('ks:gift:rendered', { detail: { present: !!next } }));
  }

  function syncCheckoutCtaState(state) {
    const drawer =
      document.querySelector('cart-drawer#cart-drawer') ||
      document.querySelector('.drawer--cart');

    if (!drawer) return;

    const belowMinimum = state === 'minimum';

    drawer.classList.toggle('ks-below-minimum', belowMinimum);

    const note = drawer.querySelector('[data-ks-minimum-note]');
    if (note) note.hidden = !belowMinimum;
  }

  function startObserver() {
    const drawerRoot = getDrawerRoot();

    if (!drawerRoot || observer) return;

    observer = new MutationObserver(function (mutations) {
      if (isApplyingUpdate) return;

      const shouldRefresh = mutations.some(function (mutation) {
        const target = mutation.target;
        const element =
          target && target.nodeType === 1
            ? target
            : target && target.parentElement
              ? target.parentElement
              : null;

        if (
          element &&
          element.closest &&
          element.closest(SLOT_SELECTOR)
        ) {
          return false;
        }

        return true;
      });

      if (shouldRefresh) {
        scheduleRefresh(700);
      }
    });

    observer.observe(drawerRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Only cart-mutating controls should trigger a section re-fetch
  // (each refresh is a full section rendering request).
  const CART_MUTATION_SELECTOR = [
    '.cart__quantity-plus',
    '.cart__quantity-minus',
    '[data-item-remove]',
    '[data-popout-option]'
  ].join(', ');

  function isInsideDrawer(target) {
    return !!target.closest(
      'cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]'
    );
  }

  document.addEventListener('change', function (event) {
    if (!isInsideDrawer(event.target)) return;

    if (event.target.matches('.cart__quantity-field, input[name="updates[]"]')) {
      scheduleRefresh(900);
    }
  });

  document.addEventListener('click', function (event) {
    if (!isInsideDrawer(event.target)) return;

    if (event.target.closest(CART_MUTATION_SELECTOR)) {
      scheduleRefresh(900);
    }
  });

  document.addEventListener('cart:updated', function () {
    scheduleRefresh(600);
  });

  document.addEventListener('cart:refresh', function () {
    scheduleRefresh(600);
  });

  document.addEventListener('theme:cart:update', function () {
    scheduleRefresh(600);
  });

  // Broadcast theme events: 'theme:cart:change' fires after the drawer is
  // rebuilt (add-to-cart included); 'theme:product:add' fires on successful
  // add-to-cart. Without these the widget only updated via the
  // MutationObserver fallback, which can miss add-to-cart flows.
  document.addEventListener('theme:cart:change', function () {
    scheduleRefresh(600);
  });

  document.addEventListener('theme:product:add', function () {
    scheduleRefresh(600);
  });

  function initCtaStateFromSlot() {
    const slot = document.querySelector(SLOT_SELECTOR);
    if (slot) syncCheckoutCtaState(slot.dataset.ksState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      startObserver();
      initCtaStateFromSlot();
    });
  } else {
    startObserver();
    initCtaStateFromSlot();
  }

  document.addEventListener('shopify:section:load', function () {
    if (observer) {
      observer.disconnect();
    }

    observer = null;
    startObserver();
  });
})();